import ModalDepartment from "./ModalDepartment";

export default ModalDepartment;
